
import React, { useState } from 'react';
import VideoCard from './VideoCard';
import { Video } from '@/lib/api';
import { useVideoActions } from '@/hooks/useVideoActions';
import VideoContextMenu from './VideoContextMenu';
import VideoActionButtons from './VideoActionButtons';
import VideoPlaylistDialog from './VideoPlaylistDialog';
import PlaylistDialog from '../playlists/PlaylistDialog';

interface VideoCardWrapperProps extends Video {
  extraActions?: React.ReactNode;
  video_id?: string; // Optional field for compatibility
}

const VideoCardWrapper = (props: VideoCardWrapperProps) => {
  const { extraActions, ...videoProps } = props;
  const videoId = props.id;
  
  const [isHovered, setIsHovered] = useState(false);
  
  // Créer l'objet Video complet pour le hook
  const videoDetails: Video = {
    id: props.id,
    title: props.title,
    thumbnail: props.thumbnail,
    channelName: props.channelName,
    channelAvatar: props.channelAvatar,
    channelId: props.channelId,
    views: props.views,
    published: props.published,
    publishedDate: props.publishedDate,
    duration: props.duration,
    video_id: props.video_id,
  };
  
  // Utiliser le nouveau hook unifié
  const {
    playlists,
    playlistVideos,
    isFavorite,
    isDialogOpen,
    setIsDialogOpen,
    isLoading,
    isCreatingPlaylist,
    setIsCreatingPlaylist,
    newPlaylistName,
    setNewPlaylistName,
    toggleFavorite,
    addToPlaylist,
    togglePlaylistMembership,
    createPlaylist
  } = useVideoActions(videoDetails);
  
  const handleCreatePlaylist = () => {
    createPlaylist(videoId);
  };
  
  return (
    <div 
      className="relative group" 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <VideoContextMenu
        isFavorite={isFavorite}
        onToggleFavorite={toggleFavorite}
        onOpenPlaylistDialog={() => setIsDialogOpen(true)}
      >
        <div className="relative">
          <VideoCard {...videoProps} />
          
          {isHovered && (
            <VideoActionButtons
              isFavorite={isFavorite}
              isInPlaylist={Object.values(playlistVideos).some(videos => videos.includes(videoId))}
              onToggleFavorite={toggleFavorite}
              onOpenPlaylistDialog={() => setIsDialogOpen(true)}
            />
          )}
          
          {extraActions}
        </div>
      </VideoContextMenu>
      
      <VideoPlaylistDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        playlists={playlists}
        isLoading={isLoading}
        playlistVideos={playlistVideos}
        videoId={videoId}
        onAddToPlaylist={addToPlaylist}
        onTogglePlaylistMembership={togglePlaylistMembership}
        onCreateNewPlaylist={() => {
          setIsDialogOpen(false);
          setIsCreatingPlaylist(true);
        }}
      />
      
      <PlaylistDialog
        isOpen={isCreatingPlaylist}
        onOpenChange={setIsCreatingPlaylist}
        playlistName={newPlaylistName}
        onPlaylistNameChange={setNewPlaylistName}
        onCreatePlaylist={handleCreatePlaylist}
      />
    </div>
  );
};

export default VideoCardWrapper;
